var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDodo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 27.239h4.03l.298-3.285c.125-1.368.896-4.701 4.18-7.09 4.104-2.984 10.149-1.79 13.208.3 2.448 1.67 3.806 5.124 4.18 6.64v3.434H31c0-2.464-.657-8.165-3.284-11.27-2.626-3.104-6.268-4.876-7.76-5.373l-.598-3.582h-1.79L17.044 5h-1.567l-.747 1.12V7.76l-1.491-.745-.971.746.446 1.12v1.27l-.895.447c-1.84.473-6.253 2.21-7.984 5.373C1.672 19.925 1 21.493 1 27.24zm10.985-4.877-.015-.273c-.121-1.94 1.866-2.09 1.866 0s-.075 2.09-.746 2.09c-1.015 0-1.06-.932-1.105-1.817zm7.075 1.816c-.597 0-.87-.3-.97-2.09-.1-1.792 1.567-1.676 1.567 0 0 1.675 0 2.09-.597 2.09z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDodo);
export default __webpack_public_path__ + "static/media/DODO.ff080c2c725ebdd0611a1e37eb96b4be.svg";
export { ForwardRef as ReactComponent };